export const PERSONAL_FORM = 'personal';
export const EVENT_FORM = 'event'